export const INITIALIZE_TERMS = "INITIALIZE_TERMS";
export const INITIALIZE_ATTACHMENTTYPES = "INITIALIZE_ATTACHMENTTYPES";
export const INITIALIZE_LANGUAGES = "INITIALIZE_LANGUAGES";

export const initializeTerms = (terms) => {
  return {
    type: INITIALIZE_TERMS,
    payload: terms,
  };
};

export const initializeAttachmentTypes = (attachmentTypes) => {
  return {
    type: INITIALIZE_ATTACHMENTTYPES,
    payload: attachmentTypes,
  };
};

export const initializeLanguages = (languages) => {
  return {
    type: INITIALIZE_LANGUAGES,
    payload: languages,
  };
};
